// extracted by mini-css-extract-plugin
export var hl = "styles-module--hl--70161";
export var icon = "styles-module--icon--dab61";
export var itemWrapper = "styles-module--itemWrapper--f1412";
export var left = "styles-module--left--dc3e0";
export var right = "styles-module--right--61a6f";
export var text = "styles-module--text--7db01";
export var textContent = "styles-module--textContent--ef37a";